const languages = {
    web_title                       : 'Pine Peak Capital Group (Hong Kong) Limited ',
    

    account_userinfo_title          : 'Identity Information',   
    account_userinfo_subtitle_1     : 'Document upload',
    account_userinfo_subtitle_2     : 'Account Information',

    please_select                   : 'please choose',
    please_input                    : 'please enter',
    please_wait                     : 'Please wait...',

    name                            : 'name',
    telephone                       : 'mobile number',
    gender                          : 'gender',
    birthday                        : 'date of birth',
    idcode                          : 'identity number',
    email                           : 'Mail',
    marriage                        : 'marriage status',
    verify_code                     : 'Verification code',

    male                            : 'male',
    female                          : 'Female',

    marriage_1                      : 'unmarried',
    marriage_2                      : 'Married',

    send_verify_code                : 'Send the verification code',
    please_upload_id_pic            : 'Upload the front and back photos of the ID card',
    shoot_fail                      : 'If the shooting fails, please try it out',
    verify_code_send_success        : 'The verification code is successfully sent',
    second                          : 'second',

    error_format_email              : 'enter the correct format email',

    next_step                       : 'Next step',

    

    account_type_title              : 'account type',
    account_type_1                  : 'Domestic bank account',
    account_type_2                  : 'Overseas bank account information',
    account_type_3                  : 'USDT',

    account_bank_title              : 'Bank card information',
    bank_upload                     : 'Bank card upload',
    bank_account_info               : 'Bank account information',
    open_bank                       : 'Bank',
    branch_bank                     : 'Affiliated branch',
    bank_number                     : 'Bank card number',
    please_branch_bank              : 'Please fill in in the format of "XX XX Sub -branch of XX Province"',
    please_upload_bank_pic          : 'Please upload a Bank card picture',

    account_hkbank_title            : 'Overseas bank account',
    account_hkbank_subtitle_1       : 'account information',
    country                         : 'country and the area',
    bank                            : 'Bank',
    bank_code                       : 'Bank code',
    bank_address                    : 'Bank address',
    account_name                    : 'account name',
    account_address                 : 'Account address',

    account_usdt_title              : 'USDT',
    account_usdt_subtitle_1         : 'account information',
    main_network_type               : 'Main network type',
    address                         : 'address',

    open_account_success_remark     : 'The pre-trial is generally completed within 1-2 working days, please wait patiently!',

    examing                         : 'under review',
    exam_no_pass                    : 'Audit failure',

    to_edit                         : 'Modify',
    to_upload                       : 'Upload',
    to_download                     : 'go download',

    all_loaded                      : 'Loaded all',
    loading                         : 'Loading....',
    submit                          : 'Submit',

    deposit_notice_check            : 'Notice to check',
    deposit_info                    : 'deposit information',
    deposit_amount                  : 'Deposit',
    deposit_method                  : 'Method of deposit',
    current_status                  : 'Current state',
    cancel_reason                   : 'Reason for Cancellation',
    submit_date                     : 'Submission date',
    transfer_info                   : 'Transfer information',
    receipt_upload                  : 'Back to the order upload',
    deposit_store                   : 'Deposit',
    receipt_upload_tip              : '* Please make sure that the actual account amount received by our company is consistent with the amount of deposit filled in.',
    confirm_upload_receipt          : 'Confirm the upload submission',
    cancel_deposit                  : 'Cancel deposit',
    cancel_deposit_tip              : 'Are you sure you want to cancel the deposit?',
    cancel_deposit_success          : 'Deposit has been successfully canceled',
    deposit_record                  : 'Deposit record',
    deposit_tip                     : 'Tips for Jinjin',
    deposit_method_tip              : 'deposit information',
    deposit_amount_limit            : 'deposit limit',
    deposit_amount_min              : 'Minimum deposit',
    deposit_amount_max              : 'maximum deposit',
    deposit_amount_rule             : 'Deposit amount, support three decimal places',

    please_upload_receipt_pic       : 'Please go back to the single picture',

    upload_receipt_notice           : 'Are you sure you want to submit the payment of money?',
    upload_receipt_success          : 'Upload success, please wait for the staff to review',
    deposit_no_upload_tip           : 'Do you still have an application for the transfer of transfer not uploading the transfer bill?',


    my_invite_code                  : 'My invitation code',
    click_copy                      : 'Click to copy',
    copy_link                       : 'copy Link',
    save_image                      : 'save Picture',
    get_image_fail                  : 'Failure to get pictures',

    share_title                     : 'invite friends to join us',
    share_subtitle                  : 'High-speed market, trading a little faster',

    invite_join_zydf                : 'Invite you to join Zhiyi East',

    invite_title                    : 'Pine Peak Capital Group (Hong Kong) Limited',
    invite_subtitle                 : 'High-speed market insight into the market',

    invite_register_success         : 'Congratulations, successful registration!',
    invite_click_download_app       : 'You can now click the button below to download the app',   

    download_ios                    : 'Download for iPhone',
    download_android                : 'Download for Android',

    id_photo                        : 'ID Photo',
    nationality                     : 'nationality',
    issuing_authority               : 'issuing authority',
    validity_period                 : 'Validity period',
    id_information_incorrect        : 'The identity information is incorrect? Click here to modify',
    other_information               : 'Other Information',
    marital_status                  : 'marital status',
    e_mail                          : 'e-mail',
    please_fill_in_the_email        : 'Please fill in the email',
    please_fill_verification_code   : 'Please fill in the verification code',
    please_enter_correct_email      : 'Please enter the correct format email',
    please_select_marital_status    : 'Please select the marriage status',
    please_fill_correct_vcode       : 'Please fill in the verification code of the correct format',
    to                              : ' to ',

    wrong_amount_minimum_deposit    : 'Error amount, minimum money:',
    wrong_amount_maximum_deposit    : 'Error amount, maximum deposit:',
    submit_a_deposit_application    : 'Are you sure you want to submit an application for deposit?',
    the_deposit_successfully        : 'The application for deposit has been successfully submitted, please upload the transfer bill as soon as possible to confirm.',

    submitted_successfully_wait     : 'Successful submission, please wait for the system processing',
    web_app_download                : 'Zhiyi Orient Securities Wealth Management Version APP Download',

    no_more_records                 : 'No more records',
    to_be_processed                 : 'To be processed',
    processed                       : 'Processed',

    feedback                        : 'Feedback',
    title                           : 'title',
    please_enter_a_feedback_title   : 'Please enter the feedback title',
    detailed_description            : 'A detailed description',
    please_enter_description        : 'Please enter a detailed description',
    feedback_successfully_submitted : 'Opinions have been successfully submitted',
    status                          : 'state',
    process_result                  : 'process result',

    overview                        : 'Overview',
    introduction                    : 'Brief introduction',
    rate_structure                  : 'Tarral structure',
    subscription_rate               : 'Subscription rate',
    subscription_amount_m           : 'Subscribed amount (m, including recognition purchase costs)',
    management_fee                  : 'management fee',
    redemption_rate                 : 'Redeem rate',
    application_share_n             : 'Application share holding time (n, for nature day)',
    document                        : 'document',
    type                            : 'type',
    update_time                     : 'Update time',
    fund_introduction               : 'Fund introduction',

    helpful                         : 'helpful',
    no_help                         : 'no help',
    not_click_repeatedly            : 'Do not repeat click',

    growth_since                    : 'Lost since its establishment',
    unit_net_value_hkd              : 'Net worth (Hong Kong dollar)',
    remaining_quota                 : 'Remaining quota',
    historical_net_worth            : 'Net worth',
    date                            : 'date',
    unit_net_value                  : 'Net value',
    daily_change                    : 'Daily rising decline',

    please_enter_the_search_keyword : 'Please enter the search keyword',

    app_download                    : 'Zhiyi Dongfang APP Download',
    application_development         : 'The application is under development, so stay tuned...',

    please_enter_valid_phone_number : 'please enter a valid phone number',
    phone_is_registered             : 'The telephone has been registered',
    phone_is_registered_download    : 'Your mobile phone number has been registered, you can download the app login directly',
    refresh_the_page                : 'Data error, please re -refresh the page',

    setting_login_password          : 'Setting login password',
    please_fill_in_the_password     : 'Please fill in the password',
    confirm                         : 'confirm',
    please_enter_password           : 'Please enter the password',
    please_enter_the_password_again : 'Please enter the password again',
    passwords_please_check          : 'The password input twice is inconsistent, please check',

    start_subscription              : 'Start subscription',
    deadline_for_subscription       : 'Out subscription',
    announcement_of_winning         : 'Publishing a Chinese sign',
    grey_market                     : 'Dark trading',
    listed                          : 'Go on the market',
    basic_information               : 'Basic Information',
    cornerstone_investor            : 'Cornerstone',
    denomination                    : 'name',
    planned_subscription_number     : 'Plan subscription (stock)',
    proportion                      : 'Proportion',
    actual_number_of_subscriptions  : 'Actual subscription number (stock)',
    sponsor                         : 'Sponsor',
    category                        : 'category',
    underwriter                     : 'Underwriter',
    company_overview                : 'Company Overview',
    company_profile                 : 'Company Profile',
    company_executives              : 'Corporate executive',
    job_title                       : 'Position',
    brief                           : 'profile',
    release_information             : 'Distribution information',

    login_has_expired               : 'The login has been invalid, please log in again',
    re_register                     : 're-register',

    previous_question               : 'Last question',
    next_question                   : 'next question',
    confirm_submission              : 'confirm submission',
    submit_a_risk_assessment        : 'Are you sure you need to submit a risk evaluation?',

    read_and_agree                  : 'I have read and agreed to related',
    start_answering_questions       : 'Start answering',

    assessment_results              : 'According to the results of risk assessment, your risk type is',
    your_risk_type                  : 'Your risk type',
    retest                          : 'retest',

    options                         : 'options',
    withdrawal_amount               : 'Withdrawal amount',
    accounts_receivable             : 'Accounts receivable',
    moderated                       : 'Moderated',
    account_balance                 : 'Account Balance',
    amount_that_can_be_withdrawn    : 'Can get the amount',
    amount_lock    					: 'Lock amount',
    withdrawal_record               : 'Withdrawal record',
    please_fill_withdrawal_amount   : 'Please fill in the withdrawal amount',
    re_modify_the_withdrawal        : 'USDT minimum withdrawal is 50, please revise the withdrawal amount',
    insufficient_account_balance    : 'Insufficient account balance, current balance:',
    extract_amount                  : 'Extraction amount',
    countries                       : 'nation',
    
    swift_code                      : 'SWIFT CODE',

    select_mainnet_type             : 'Please select the main network type',
    qr_code_picture                 : 'QR code picture',
    please_enter_country            : 'Please fill in the country',
    please_fill_in_the_bank         : 'Please fill in the bank',
    please_fill_in_the_bank_address : 'Please fill in the bank address',
    please_fill_in_the_account_name : 'Please fill in the account name',
    please_fill_in_the_bank_card    : 'Please fill in the bank card number',
    please_fill_in_account_address  : 'Please fill in the account address',
    please_fill_in_swift_code       : 'Please fill in Swift Code',
    please_fill_in_the_address      : 'Please fill in the address',
    please_upload_a_qr_code_image   : 'Please upload a QR code picture',
    erc20                           : 'ERC20 (recommendation)',

    overseas_bank_card              : 'Overseas bank card',
    please_confirm_address          : 'Please confirm that your receipt address is not correct, and our company will transfer the funds according to the receipt address you provided',
    withdrawal_successfully_submit  : 'The application for money has been successfully submitted',


    audited                         : 'Audited',
    cancel                          : 'Canceled',
    pass                            : 'Pass',
    not_pass                        : 'Not Pass',
    debited                         : 'Existing money',

    extract                         : 'extract',
    withdrawal_tips                 : 'Withdrawal Tips',
    withdrawal_information          : 'Withdrawal information',
    cancel_apply                    : 'cancel application',
    handling_fee                    : 'Handling fee',
    audit_date                      : 'Review date',
    transfer_date                   : 'Transfer date',
    cancel_the_withdrawal           : 'Are you sure you want to cancel the withdrawal request?',
    cancelled_successfully          : 'The application for money has been successfully canceled',

    each_handling_fee               : 'Each handling fee',
    total                           : 'total',
    please_select_an_account_type   : 'Please select the account type',
    incorrect_minimum_withdrawal    : 'Error amount, minimum money:',
    amount_wrong_maximum_withdrawal : 'Error amount, maximum deposit:',
    this_feature_is_being_improved  : 'This feature is being improved',
    stable_currency                 : 'Stable Currency',
    other_assets                    : 'Other Assets',
 
}

export default languages